import React, { useState } from 'react';
import { Button, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { IdeaLikeHandler } from 'components/lib/Ideas';
import IdeaCardView from 'components/lib/Cards/IdeaCard';
import TagModalChooser from 'components/lib/Choosers/Tags/TagModalChooser';
import actions from 'actions';
import util from 'utils/utils';

export const labels = [
  { colour: 'green', text: 'Green' },
  { colour: 'yellow', text: 'Yellow' },
  { colour: 'orange', text: 'Orange' },
  { colour: 'red', text: 'Red' },
  { colour: 'purple', text: 'Purple' },
  { colour: 'blue', text: 'Blue' },
  { colour: 'pink', text: 'Pink' },
];

// const entityIcons = { PERSON: 'user', LOCATION: 'map pin', ORGANIZATION: 'building', COMMERCIAL_ITEM: 'box', EVENT: 'calendar alternate outline', DATE: 'calendar outline', QANTITY: 'numbered list', TITLE: 'font', OTHER: 'tag' };

const IdeaCard = ({
  idea,
  ideasVotedFor,
  challenge,
  user,
  addTag,
  unTag,
  voteForIdea,
  listView,
  pinIdea,
  labelIdea,
  onSelectIdea,
  selectedIdeas,
  ideaActions,
  onUpdateIdea,
  removeAssessors,
  onClosePreview,
  invitations,
  setPreviewOpen,
  setOpenToComments,
  onRemoveExternalInvitation,
  fetchIdeas,
  hasPinnedIdea,
  allChallengeProjectLanes,
  updateProjectLane,
}) => {
  const ideaId = idea?._id;
  const usedVotes = (parseInt(challenge.voteLimit, 10) === ideasVotedFor);

  const [tagsOpen, setTagsOpen] = useState(false);
  const openProps = tagsOpen ? { open: tagsOpen } : {};
  return (
    <IdeaCardView
      challenge={challenge}
      isYours={util.canEditIdea(user, idea)}
      key={ideaId}
      idea={idea}
      usedVotes={usedVotes}
      voteForIdea={voteForIdea}
      invitations={invitations}
      fetchIdeas={fetchIdeas}
      footer={(
        <div style={{
          display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', width: '100%', marginBottom: 10,
        }}>
          <Popup on='hover' hoverable style={{ zIndex: 1000 }}
            trigger={
              <Button icon='hashtag' size='tiny' label={{ basic: true, pointing: 'left', content: idea.tags?.length ?? 0 }} style={{ marginRight: 5, marginLeft: 14 }} />
            }
            content={
              <div>
                <h4>Tags</h4>
                <TagModalChooser
                  trigger={<Button compact circular icon='hashtag' content='Edit tags' size='tiny' style={{ marginLeft: 3 }} />}
                  tags={idea.fullTags}
                  availableTags={challenge.tagList}
                  addTag={addTag}
                  removeTag={unTag}
                  canEdit={util.canManageChallenge(user, challenge)}
                  onStateChange={(state) => setTagsOpen(state)}
                />
              </div>
            }
            {...openProps}
          />
          {!challenge?.preventIdeaComments
            && <Button as={Link} to={`/ideas/${idea._id}#comments`} color={idea.commentCount ? 'blue' : 'grey'} icon='comments' size='tiny' label={idea.commentCount ? { basic: true, pointing: 'left', content: idea.commentCount } : null} style={{ marginLeft: 5, marginRight: 5 }} />
          }

          {(util.canManageChallenge(user, challenge) || challenge.votingVisibility === 'users')
            ? (
              <IdeaLikeHandler
                idea={idea}
                challenge={challenge}
                onLikeIdea={voteForIdea}
                trigger={(
                  <Button
                    disabled={usedVotes && !idea.votedFor}
                    color={idea.votedFor ? 'green' : 'grey'}
                    icon='thumbs up'
                    style={{ marginLeft: 5 }}
                    size='tiny'
                    label={(util.canManageChallenge(user, challenge) || challenge.voteCountVisibility === 'users') ? { basic: true, pointing: 'left', content: idea.voteCount || 0 } : null}
                  />
                )}
              />
            ) : null
          }
        </div>
      )}
      pinIdea={pinIdea}
      projectManagement={idea?.projectManagement}
      labels={labels}
      addTag={addTag}
      unTag={unTag}
      labelIdea={labelIdea}
      onSelect={onSelectIdea}
      isSelected={selectedIdeas.indexOf(idea._id) > -1}
      onHeaderClicked={() => onSelectIdea(idea)}
      removeAssessors={removeAssessors}
      ideaActions={ideaActions}
      listView={listView}
      onUpdateIdea={onUpdateIdea}
      assessmentEnabled={challenge?.assessmentEnabled}
      onClosePreview={onClosePreview}
      setPreviewOpen={setPreviewOpen}
      setOpenToComments={setOpenToComments}
      onRemoveExternalInvitation={onRemoveExternalInvitation}
      hasPinnedIdea={hasPinnedIdea}
      allChallengeProjectLanes={allChallengeProjectLanes}
      updateProjectLane={updateProjectLane}
    />
  );
};

const mapStateToProps = (state) => ({ user: state.user });

const mapDispatchToProps = (dispatch) => ({ updateFilters: (data) => dispatch(actions.challenges.updateIdeaFilters(data)) });

export default connect(mapStateToProps, mapDispatchToProps)(IdeaCard);
